import { render, staticRenderFns } from "./ClientPostLoginOption.vue?vue&type=template&id=5097b41e&"
import script from "./ClientPostLoginOption.vue?vue&type=script&lang=js&"
export * from "./ClientPostLoginOption.vue?vue&type=script&lang=js&"
import style0 from "./ClientPostLoginOption.vue?vue&type=style&index=0&id=5097b41e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports